import { render, staticRenderFns } from "./ProjectSettingsScreen.vue?vue&type=template&id=a6488ee6"
import script from "./ProjectSettingsScreen.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports